import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledSources = styled.div`
  display: block;
  border: 1px solid #e4e8ec;
  border-radius: 8px;
  margin-bottom: 16px;
`
export const StyledHeading = styled.button`
  padding: 16px;
  text-transform: uppercase;
  cursor: pointer;
  width: 100%;
  text-align: start;
`

export const StyledExpandableContainer = styled.div`
  overflow: hidden;
  height: 0;
  transition: height 0.25s ease;
  background-color: white;
  &[data-expand='true'] {
    height: var(--expand-height);
  }
  .source-wrapper {
    white-space: pre-wrap;
    padding: 0px 1rem 1rem;
    word-break: break-word;
    line-height: 1.55;
    a {
      display: inline-block;
      color: ${theme.colors.primaryBase};
      font-weight: normal;
      text-decoration: none;
      word-break: break-word;
    }
  }
`
